<template lang="pug">
	form.login-form(name='form', novalidate v-on:submit.prevent="")

		.login-body

			h3 Returning Customer
			br

			p Please login:
			br

			.alert.alert-warning(v-if='authReason') {{authReason}}
			.alert.alert-danger(v-if='authError') {{authError}}

			.login-lbl
				// label {{ $t('label.username') }}
				label Username:
				b-form-input.login-field(name='login', v-model='user.account.name', required, autofocus, novalidate='')

			.login-lbl
				// label {{ $t('label.password') }}
				label Password:
				b-form-input.login-field(name="pass", @keyup.enter.stop.native="login", type='password', v-model='user.account.password', required, novalidate='')

			div.text-right
				router-link.forgot-pass(:to="{name: 'forgot-password'}") {{ $t('login.forgotPass') }}

			.btn-login-cnt
				b-button(variant="success", size="lg", @click='login') {{ $t('login.login') }}

			p If you are having any issues, please #[a(href='mailto:customer.service@easytitle24.com') email us.]
</template>

<script>
import Vue from 'vue'
import store from 'CommonApp/store'

export default {
	name: 'login-form',
	props: ['goodbye', 'redirect', 'error'],
	data () {
		return {
			// The reason that we are being asked to login - for instance because we tried
			// to access something to which we are not authorized We could do something
			// different for each reason here but to keep it simple...
			authReason: null,
			// Any error message from failing to login
			authError: null,
			// The model for the login form
			user: {
				account: {},
				person: {}
			}
		}
	},
	created () {
		if (this.goodbye) {
			if (this.goodbye === 'TRUE') {
				this.authReason = this.$t('login.msg.goodbye')
			} else if (this.goodbye === 'FORCED_LOGOUT') {
				this.authReason = this.$t('login.msg.forcedLogout')
			}
		}

		if (this.error !== '') {
			this.authError = this.$t(this.error)
		}
	},
	methods: {
		// Attempt to authenticate the user specified in the form's model
		login () {
			console.debug('login controller')
			// Clear any previous security errors
			this.authError = null

			// Try to login
			Vue.e24.security.login(this.user.account.name, this.user.account.password).then((loggedIn) => {
				if (!loggedIn) {
					// If we get here then the login failed due to bad credentials
					this.authError = this.$t('login.error.invalidCredentials')
					this.authReason = null
				} else if (this.$route.name === 'connect') {
					let redirect = (this.entryUrl || '/')
					// Clean requested url
					store.dispatch({
						type: 'updateEntryUrl',
						value: null
					})
					this.$router.push(redirect)
				}
			}, (err) => {
				// If we get here then there was a problem with the login request to the server
				console.error('Server is unavailable or returned an error', err)
				this.authError = this.$t('login.error.serverError')
				this.authReason = null
			})
		}
	},
	computed: {
		entryUrl () {
			return this.$store.getters.entryUrl
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/common/security/login-form.vue